import React from "react";
import { RotatingLines } from "react-loader-spinner";

interface LoaderProps {
  size?: string;
}

export const Loader: React.FC<LoaderProps> = ({ size }) => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <RotatingLines
        strokeColor="#8B5CF6"
        strokeWidth="5"
        animationDuration="0.75"
        width={size ? size : "60"}
        visible={true}
      />
    </div>
  );
};
